import { Roles, tokenDecodedUser } from "utils/functions";

export interface IUserData {
  username: string;
  email: string;
  locationId: number;
  location: string;
  warehouseCode: string;
  jobTitle: string;
  role: string;
  firstAccess: boolean;
  acceptLanguage: string;
}

export interface ITokenResponse {
  email: string;
  name: string;
  token: string;
  role: string;
  locationId: string;
  locationDescription: string;
  warehouseCode: string;
  exp: number;
  acceptLanguage: string;
}

export interface IIdentityTokenResponse {
  token: string;
  firstAccess: boolean;
  kcToken?: string;
}

export interface ILocationsList {
  id: number;
  description: string;
}

export interface IUserSessionState {
  isLoading: boolean;
  userData: IUserData;
  isConcierge: boolean;
  isAdmin: boolean;
  disabledRegisterButton: boolean;
  isCollapseSidebar: boolean;
  locationsList: ILocationsList[];
  menuItemActive: MenuItemActive;
}

export enum MenuItemActive {
  LOBBY = "1",
  UNITS = "4",
  USERS = "5",
  USER_EDIT = "6",
  LOCATION = "7",
  LOCATION_EDIT = "8",
  DOCUMENTS = "9",
  PROCESS = "10",
  YARD_MANAGEMENT = "11",
  ATTENDANCE = "12",
  INBOUND_OUTBOUND = "13",
  MOVEMENTS = "14",
  VEHICLE_DASHBOARD = "15",
  DASHBOARD = "17",
  READERS = "18",
  TAGS = "19",
}

export const userData = {
  username: "",
  email: "",
  location: "",
  locationId: null,
  warehouseCode: "",
  jobTitle: "",
  role: "",
  isConcierge: false,
  firstAccess: false,
  acceptLanguage: "",
};

let localState = userData;
let isAdmin = false;
let isConciergeState = false;

if (typeof window !== "undefined") {
  tokenDecodedUser(userData);
  isAdmin = userData.role === Roles.ADMIN;
  localState = userData;
  isConciergeState = userData.isConcierge;
}

export const defaultState: IUserSessionState = {
  userData: localState,
  locationsList: null,
  isLoading: false,
  isConcierge: isConciergeState,
  isAdmin,
  disabledRegisterButton: false,
  isCollapseSidebar: true,
  menuItemActive: MenuItemActive.LOBBY,
};
